export const socialsData = {
  github: "https://github.com/harsh-rajpal",
  linkedIn: "https://www.linkedin.com/in/harsh-rajpal/",
  blogger: "https://dev.to/harshrajpal",

  leetcode: "https://leetcode.com/harsh-rajpal/",
};
